/* Free Swatches July 2026 */
document.addEventListener('DOMContentLoaded', () => {
  const dataElement = document.querySelector(
    '#free-swatch-data'
  );

  if (!dataElement) return;

  const swatchWrapper = document.querySelector(
    '.OrderFreeSwatchWrapper'
  );

  if (!swatchWrapper) return;

  const swatchData = JSON.parse(
    dataElement.textContent
  );

  const button = swatchWrapper.querySelector(
    '.OrderFreeSwatch'
  );

  const infoWrapper = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoWrapper'
  );

  const infoIcon = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoIcon'
  );

  const infoClose = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoClose'
  );

  const infoBackdrop = swatchWrapper.querySelector(
    '.OrderFreeSwatchInfoBackdrop'
  );

  button.addEventListener('click', async () => {
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: swatchData.variantId,
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        throw new Error(
          'Failed to add free swatch'
        );
      }

      button.textContent = '✓ Swatch added';

      button.classList.add('is-added');

      window.SLIDECART_UPDATE(() => {
        window.SLIDECART_OPEN();
      });

    } catch (error) {
      console.error(
        'Could not add free swatch:',
        error
      );

      button.disabled = false;

      button.textContent =
        'Order a free swatch';
    }
  });

  infoIcon.addEventListener('click', () => {
    if (
      window.matchMedia(
        '(max-width: 749px)'
      ).matches
    ) {
      infoWrapper.classList.add(
        'is-open'
      );
    }
  });

  infoClose.addEventListener('click', () => {
    infoWrapper.classList.remove(
      'is-open'
    );
  });

  infoBackdrop.addEventListener('click', () => {
    infoWrapper.classList.remove(
      'is-open'
    );
  });

  swatchWrapper
    .querySelector(
      '.OrderFreeSwatchInfoBox'
    )
    .addEventListener(
      'click',
      event => {
        event.stopPropagation();
      }
    );
});


/* Custom BIS estimate message */
(function () {
  const estimateBox = document.getElementById('product-estimated-stock');
  if (!estimateBox) return;

  const estimateText = estimateBox.querySelector('.ProductEstimatedStock__Text');
  const variantDateMap = window.variantDateMap || {};

  function updateEstimatedStock() {
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!variantInput) return;

    const variantData = variantDateMap[variantInput.value];

    const date = variantData?.date;

    if (!date || date.trim().toLowerCase() === 'not restocking') {
      estimateBox.style.display = 'none';
      return;
    }

    estimateText.innerHTML = `Estimated back in stock: <strong>${date}</strong>`;
    estimateBox.style.display = 'block';

    estimateText.innerHTML = `Estimated back in stock: <strong>${variantData.date}</strong>`;
    estimateBox.style.display = 'block';
  }

  updateEstimatedStock();

  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

  if (variantInput) {
    const observer = new MutationObserver(updateEstimatedStock);

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('form[action*="/cart/add"] [name="id"]')) {
      updateEstimatedStock();
    }
  });
})();

/* Custom BIS estimate popup */
(function () {
  const overlay = document.getElementById('custom-bis-overlay');
  const form = document.getElementById('custom-bis-form');
  const variantSelect = document.getElementById('custom-bis-variant');
  const estimateBox = document.getElementById('custom-bis-estimate');
  const successBox = document.getElementById('custom-bis-success');

  if (!overlay || !form || !variantSelect) return;

  function updateEstimate() {
    const variantId = variantSelect.value.replace('$shopify:::$default:::', '');
    const date = window.variantDateMap?.[variantId]?.date;
    const emailInput = document.getElementById('custom-bis-email');
    const submitButton = form.querySelector('button[type="submit"]');
    const notRestocking = typeof date === 'string' && date.trim().toLowerCase() === 'not restocking';

    emailInput.style.display = notRestocking ? 'none' : '';
    submitButton.style.display = notRestocking ? 'none' : '';

    if (!date) {
      estimateBox.style.display = 'none';
      estimateBox.innerHTML = '';
      return;
    }

    estimateBox.style.display = 'block';
    estimateBox.innerHTML = `<span class="custom-bis-ring"></span> Estimated back in stock: <strong>${date}</strong>`;
  }

  function openModal() {
    successBox.innerHTML = '';
    successBox.removeAttribute('class');

    if (!variantSelect.options.length) {
      successBox.innerHTML = 'All variants are currently available.';
      successBox.classList.add('error');
      return;
    }

    updateEstimate();
    overlay.classList.add('active');
  }

  function closeModal() {
    overlay.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.klaviyo-bis-trigger');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    openModal();
  }, true);

  document.querySelector('.custom-bis-close')?.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  variantSelect.addEventListener('change', updateEstimate);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    successBox.innerHTML = '';
    successBox.removeAttribute('class');

    const variantId = variantSelect.value;
    const rawVariantId = variantId.replace('$shopify:::$default:::', '');
    const date = window.variantDateMap?.[rawVariantId]?.date;

    if (
      typeof date === 'string' &&
      date.trim().toLowerCase() === 'not restocking'
    ) {
      successBox.innerHTML = 'This size is not being restocked.';
      successBox.classList.add('error');
      return;
    }

    const email = document.getElementById('custom-bis-email').value.trim();
    
    if (!email || !variantId) {
      successBox.innerHTML = 'Please select a size and enter an email.';
      successBox.classList.add('error');
      return;
    }

    try {
      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=H46yBQ',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: variantId
                  }
                }
              }
            }
          })
        }
      );

      if (response.status === 202) {
        const marketingConsent = false;

        if (marketingConsent) {
          const marketingResponse = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=H46yBQ',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'revision': '2024-06-15'
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email
                        }
                      }
                    },
                    custom_source: 'Back in Stock'
                  },
                  relationships: {
                    list: {
                      data: {
                        type: 'list',
                        id: 'QPAnNj'
                      }
                    }
                  }
                }
              })
            }
          );

          console.log('Marketing status:', marketingResponse.status);
          console.log('Marketing response:', await marketingResponse.text()); 

          if (marketingResponse.status !== 202) {
            console.error('Marketing subscription failed:', marketingResponse.status);
          }
        }

        successBox.innerHTML = "We'll let you know when it's available.";
        successBox.classList.add('success');
        form.reset();
        updateEstimate();
        return;
      }

      successBox.innerHTML = `Something went wrong (${response.status}).`;
      successBox.classList.add('error');

    } catch (err) {
      console.error(err);
      successBox.innerHTML = 'Something went wrong. Please try again.';
      successBox.classList.add('error');
    }
  });
})();


(() => {
  const DEBUG = true;
  const NATIVE_ATC_SELECTOR = '.ProductForm__AddToCart[data-action="add-to-cart"]';
  const BUNDLE_ATC_SELECTOR = '[data-kaching-bundle-atc]';
  const initializedForms = new WeakSet();

  function initDualAtc(form) {
    if (initializedForms.has(form)) return;

    const nativeAtc = form.querySelector(NATIVE_ATC_SELECTOR);
    const bundleAtc = form.querySelector(BUNDLE_ATC_SELECTOR);

    if (!nativeAtc || !bundleAtc) return;

    function getKachingElements() {
      const root = form.querySelector('kaching-bundle');
      if (!root) return {};

      const block = root.querySelector('kaching-bundles-block');
      const bar = root.querySelector('.kaching-bundles__bar[data-deal-bar-id]');

      if (!bar) return { root, block };

      return {
        root,
        block,
        bar,
        dealId: bar.dataset.dealBarId,
        radio: bar.querySelector('input[type="radio"]'),
        barMain: bar.querySelector('.kaching-bundles__bar-main')
      };
    }

    const initial = getKachingElements();

    if (
      !initial.root ||
      !initial.block ||
      !initial.bar ||
      !initial.dealId ||
      !initial.radio ||
      !initial.barMain
    ) {
      return;
    }

    document.documentElement.classList.add('has-kaching-bundle');

    initializedForms.add(form);

    const dealId = initial.dealId;

    /*
     * Kaching is allowed to load preselected.
     *
     * After initialization, deal-bar-selected becomes
     * our source of truth.
     */
    let currentDealId =
      initial.radio.checked ||
      initial.bar.classList.contains('kaching-bundles__bar--selected')
        ? dealId
        : null;

    function log(label, data = null) {
      if (!DEBUG) return;

      if (data !== null) {
        console.log(`[Dual ATC] ${label}`, data);
      } else {
        console.log(`[Dual ATC] ${label}`);
      }
    }

    /*
     * Official Kaching events.
     */
    initial.block.addEventListener('deal-bar-selected', event => {
      currentDealId = event.detail?.dealBarId ?? null;

      log('deal-bar-selected', {
        dealBarId: currentDealId,
        preselected: event.detail?.preselected
      });
    });

    initial.block.addEventListener('variants-changed', event => {
      log('variants-changed', event.detail);
    });

    /*
     * Prestige updates ?variant= when the normal product
     * variant is selected.
     *
     * Kaching can overwrite select[name="id"], so the URL
     * is the safer source for the regular product selection.
     */
    function getRegularVariantId() {
      const variantId = new URL(window.location.href)
        .searchParams
        .get('variant');

      if (!variantId) return null;

      const select = form.querySelector('select[name="id"]');

      if (
        !select ||
        !select.querySelector(`option[value="${variantId}"]`)
      ) {
        return null;
      }

      return variantId;
    }

    function restoreRegularVariant(variantId) {
      if (!variantId) return;

      const select = form.querySelector('select[name="id"]');
      if (!select) return;

      const option = select.querySelector(
        `option[value="${variantId}"]`
      );

      if (!option) return;

      select.value = variantId;

      log('Restored regular variant', variantId);
    }

    function nextFrame() {
      return new Promise(resolve => {
        requestAnimationFrame(resolve);
      });
    }

    /*
     * Wait until Kaching confirms BOTH:
     *
     * 1. deal selection changed
     * 2. variant state finished updating
     */
    function waitForKachingTransition(expectedDealId, timeout = 2000) {
      const { block } = getKachingElements();

      if (!block) {
        return Promise.reject(
          new Error('Kaching bundles block not found.')
        );
      }

      return new Promise((resolve, reject) => {
        let dealChanged = false;
        let variantsChanged = false;
        let variantsDetail = null;

        const timer = setTimeout(() => {
          cleanup();

          reject(
            new Error(
              `Timed out waiting for Kaching deal transition to ${expectedDealId}`
            )
          );
        }, timeout);

        function cleanup() {
          clearTimeout(timer);

          block.removeEventListener(
            'deal-bar-selected',
            handleDealChange
          );

          block.removeEventListener(
            'variants-changed',
            handleVariantsChange
          );
        }

        function maybeResolve() {
          if (!dealChanged || !variantsChanged) return;

          cleanup();

          resolve({
            dealBarId: expectedDealId,
            variants: variantsDetail
          });
        }

        function handleDealChange(event) {
          const selectedDealId =
            event.detail?.dealBarId ?? null;

          if (selectedDealId !== expectedDealId) return;

          dealChanged = true;

          log('Expected deal state reached', selectedDealId);

          maybeResolve();
        }

        function handleVariantsChange(event) {
          variantsChanged = true;
          variantsDetail = event.detail;

          log(
            'Variant state updated during transition',
            event.detail
          );

          maybeResolve();
        }

        block.addEventListener(
          'deal-bar-selected',
          handleDealChange
        );

        block.addEventListener(
          'variants-changed',
          handleVariantsChange
        );
      });
    }

    /*
     * REGULAR MODE:
     * ask Kaching to genuinely deselect itself.
     */
    async function ensureBundleInactive() {
      const { barMain } = getKachingElements();

      if (!barMain) {
        throw new Error('Kaching bundle control not found.');
      }

      if (currentDealId === null) {
        log('Bundle already OFF.');
        return;
      }

      log('Turning bundle OFF.');

      const transition = waitForKachingTransition(null);

      barMain.click();

      await transition;
      await nextFrame();

      log('Bundle OFF confirmed.');
    }

    /*
     * BUNDLE MODE:
     * select the discovered Kaching deal.
     */
    async function ensureBundleActive() {
      const { barMain } = getKachingElements();

      if (!barMain) {
        throw new Error('Kaching bundle control not found.');
      }

      if (currentDealId === dealId) {
        log('Bundle already ON.');
        return;
      }

      log('Turning bundle ON.', {
        dealId
      });

      const transition = waitForKachingTransition(dealId);

      barMain.click();

      await transition;
      await nextFrame();

      log('Bundle ON confirmed.');
    }

    let bypassRegularGuard = false;
    let regularModePromise = null;

    /*
     * Start deselecting Kaching immediately when the customer
     * presses the regular ATC.
     */
    nativeAtc.addEventListener('pointerdown', () => {
      if (bypassRegularGuard) return;
      if (currentDealId === null) return;

      if (!regularModePromise) {
        regularModePromise = ensureBundleInactive();
      }
    }, true);

    /*
     * REGULAR ADD TO CART
     *
     * Bundle ON:
     *   turn bundle OFF
     *   wait for Kaching
     *   restore Prestige variant
     *   replay native ATC
     *
     * Bundle already OFF:
     *   let Prestige work normally
     */
    nativeAtc.addEventListener('click', async event => {
      if (bypassRegularGuard) {
        log('Native ATC bypass.');
        return;
      }

      const regularVariantId = getRegularVariantId();

      log('REGULAR ATC clicked', {
        regularVariantId,
        currentDealId,
        switchingToRegular: !!regularModePromise
      });

      /*
       * Kaching already genuinely OFF and no transition
       * is currently finishing.
       */
      if (!regularModePromise && currentDealId === null) {
        restoreRegularVariant(regularVariantId);

        log(
          'Bundle already OFF. Allowing normal Prestige ATC.'
        );

        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        if (!regularModePromise) {
          regularModePromise = ensureBundleInactive();
        }

        await regularModePromise;

        /*
         * Kaching resets the Shopify variant when deselected.
         * Restore the actual Prestige selection AFTER its
         * variants-changed event has finished.
         */
        restoreRegularVariant(regularVariantId);

        await nextFrame();

        log('Ready for regular native ATC', {
          regularVariantId,
          nativeVariantId:
            form.querySelector('select[name="id"]')?.value,
          currentDealId
        });

        delete form.dataset.kachingBundleSubmit;

        bypassRegularGuard = true;

        try {
          nativeAtc.click();
        } finally {
          bypassRegularGuard = false;
        }
      } catch (error) {
        console.error(
          '[Dual ATC] Could not switch to regular mode:',
          error
        );
      } finally {
        regularModePromise = null;
      }
    }, true);

    /*
     * BUNDLE ADD TO CART
     *
     * Select Kaching if necessary, then reuse the original
     * Prestige ATC.
     *
     * The data attribute tells theme.js not to require
     * this.currentVariant for a Kaching bundle submission.
     */
    bundleAtc.addEventListener('click', async event => {
      event.preventDefault();

      if (bundleAtc.dataset.loading === 'true') return;

      bundleAtc.dataset.loading = 'true';
      bundleAtc.setAttribute('aria-busy', 'true');

      console.group('[Dual ATC] BUNDLE ATC');

      try {
        log('Bundle ATC clicked', {
          dealId,
          currentDealId
        });

        await ensureBundleActive();

        log('Ready for bundle native ATC.');

        form.dataset.kachingBundleSubmit = 'true';

        bypassRegularGuard = true;

        try {
          nativeAtc.click();
        } finally {
          bypassRegularGuard = false;

          setTimeout(() => {
            delete form.dataset.kachingBundleSubmit;
          }, 0);
        }
      } catch (error) {
        delete form.dataset.kachingBundleSubmit;

        console.error(
          '[Dual ATC] Could not switch to bundle mode:',
          error
        );
      } finally {
        bundleAtc.dataset.loading = 'false';
        bundleAtc.removeAttribute('aria-busy');

        console.groupEnd();
      }
    });

    /*
     * We only reveal the custom button once we've successfully
     * found Kaching and discovered its deal ID.
     */
    bundleAtc.hidden = false;

    log('INITIALIZED', {
      discoveredDealId: dealId,
      currentDealId
    });
  }

  function init() {
    document
      .querySelectorAll('form.ProductForm')
      .forEach(initDualAtc);
  }

  init();

  const observer = new MutationObserver(init);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();